import { Button, Group, Stack, Text } from '@mantine/core';
import { t } from 'i18next';
import { useState } from 'react';

import { isCompleteTwoFactorCode, twoFactorRequestErrorMessage } from '@/auth/twoFactor';
import stopPropagation from '@/utils/form';

import { TwoFactorCodeInput } from './TwoFactorCodeInput';

type TwoFactorPromptFormProps<T> = {
	description: string;
	attempt: (code: string) => Promise<T>;
	onSuccess: (value: T) => void;
};

export function TwoFactorPromptForm<T>({ description, attempt, onSuccess }: TwoFactorPromptFormProps<T>) {
	const [code, setCode] = useState('');
	const [error, setError] = useState<string>();
	const [isSubmitting, setIsSubmitting] = useState(false);

	const submit = async () => {
		setIsSubmitting(true);
		setError(undefined);
		try {
			onSuccess(await attempt(code.trim()));
		} catch (err) {
			setError(twoFactorRequestErrorMessage(err));
			setCode('');
			setIsSubmitting(false);
		}
	};

	return (
		<Stack component="form" onSubmit={stopPropagation(() => void submit())}>
			<Text size="sm">{description}</Text>
			<TwoFactorCodeInput
				value={code}
				onChange={value => {
					setCode(value);
					setError(undefined);
				}}
				error={error}
				disabled={isSubmitting}
			/>
			<Group justify="flex-end">
				<Button type="submit" loading={isSubmitting} disabled={!isCompleteTwoFactorCode(code)}>
					{t('twoFactor.prompt.submit')}
				</Button>
			</Group>
		</Stack>
	);
}
